var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 954,
    viewBox: "0 0 388 954",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385.89 952.354C310.846 872.241 299.517 855.492 255.706 777.899C244.97 758.89 228.966 722.608 214.98 678.6C210.786 665.43 207.128 652.438 203.893 639.681C180.856 548.398 189.355 450.901 210.775 356.422C265.439 115.362 163.97 -123.151 -27.0434 -215.104C-218.386 -307.207 -455.469 -232.331 -586.909 -82.3585C-604.01 -62.8441 -680.365 29.8447 -705.013 139.75C-782.933 486.748 -462.367 674.252 40.2895 852.323C50.0687 855.779 96.8985 870.291 106.871 873.11L385.92 952.393L385.89 952.354Z",
    stroke: "black",
    strokeOpacity: 0.49,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape4);
export default __webpack_public_path__ + "static/media/shape4.c1ec68508e20fdbeced51e41631da873.svg";
export { ForwardRef as ReactComponent };